/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Support_Form_SendInputs */

const en_support_form_send = /** @type {(inputs: Support_Form_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send message`)
};

const id_support_form_send = /** @type {(inputs: Support_Form_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kirim pesan`)
};

/**
* | output |
* | --- |
* | "Send message" |
*
* @param {Support_Form_SendInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const support_form_send = /** @type {((inputs?: Support_Form_SendInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Support_Form_SendInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_support_form_send(inputs)
	return en_support_form_send(inputs)
});